export const audioCost = 5;
export const superchargedAudioCost = 8;
export const thinkingCost = 3;
export const superchargeCost = 8;
export const baseMessageCost = 5;
export const superchargeUpchargeCost = superchargeCost - baseMessageCost;
export const freeModeOverride = () => {
  return false;
};
